import axios from 'axios';
import moment from 'moment';
import { Component } from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { validateEditEmployeeForm } from "../utils/validation";
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";

export default class EmployeeEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {

      user: {
        id: null,
        fullName: '',
        role: '',
        active: false,
        departmentId: '',
        reportid: '',
        roleId: '',
        // password: '',
        showPassword: false,
      },
      userPersonalInfo: {
        id: null,
        dateOfBirth: null,
        gender: '',
        maritalStatus: '',
        fatherName: '',
        idNumber: null,
        address: '',
        city: '',
        country: '',
        mobile: '',
        phone: null,
        emailAddress: ''
      },
      jobs: [{
        id: null,
        endDate: '',
        jobTitle: '',
        startDate: ''
      }],
      userFinancialInfo: {
        id: null,
        esicStatus: '',
        otStatus: "",
        bankName: '',
        accountName: '',
        accountNumber: '',
        iban: '',
        employmentType: '',
        salaryBasic: 0,
        salaryGross: 0,
        salaryNet: 0,
        allowanceHouseRent: 0,
        allowanceMedical: 0,
        allowanceSpecial: 0,
        allowanceFuel: 0,
        allowancePhoneBill: 0,
        allowanceOther: 0,
        allowanceTotal: 0,
        deductionProvidentFund: 0,
        deductionTax: 0,
        deductionOther: 0,
        deductionTotal: 0,
        OtWorkingHours: 0,
      },
      reportingUser: {
        fullName: '',
        reportid: ''
      },
      department: {
        departmentId: null,
        departmentName: null
      },
      departments: [],
      employeeList: [],
      roleList: [],
      employee: {
        emailAddress: null,
        Aadhaar_number: "",
        pan_number: "",
        esic_number: "",
        pf_number: "",
        nominee_name: "",
        nominee_relation: "",
      },
      hasError: false,
      errMsg: "",
      completed: false,
      falseRedirect: false,
      isEdit: true,
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: true,
      forDisplayReportUser: '',
      errors: {
        user: {},
        userPersonalInfo: {},
        userFinancialInfo: {},
        employee: {},
        reportingUser: {},
        jobs: [],
      },
    };
  }

  handleEcisChange = (event) => {
    const { value } = event.target;
    console.log("Selected ESIC Value:", value);

    this.setState((prevState) => ({
      userFinancialInfo: {
        ...prevState.userFinancialInfo,
        esicStatus: value,
        esic_number: value === "No" ? "" : prevState.userFinancialInfo.esic_number, // Match capitalized "No"
      },
    }), () => {
      console.log("Updated ESIC State:", this.state.userFinancialInfo.esicStatus);
    });
  };




  handleOTChange = (event) => {
    const { value } = event.target;
    this.setState((prevState) => ({
      userFinancialInfo: {
        ...prevState.userFinancialInfo,
        otStatus: value,
      },
    }));
  };
  componentDidMount() {
    this.setState({ loading: true });
    this.fetchData();
    this.fetchRoleData();
    if (this.props.location.state) {
      axios({
        method: 'get',
        url: 'users/' + this.props.location.state.selectedUser.id,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
        .then(res => {
          let user = res.data;
          console.log("user", user);
          this.setState({ user: user });

          if (user.jobs && user.jobs.length > 0) {
            const formattedJobs = user.jobs.map(job => ({
              ...job,
              startDate: job.startDate ? moment(job.startDate).toDate() : null,
              endDate: job.endDate ? moment(job.endDate).toDate() : null
            }));
            this.setState({ jobs: formattedJobs });
          }
          // debugger;
          console.log("user.reportingUser---pk", user.reportingUser);
          this.setState({ reportingUser: user.reportingUser });
          this.setState({ forDisplayReportUser: res?.data?.reportingUser?.fullName });
          this.setState({ department: user.department });
          if (user.user_personal_info.dateOfBirth) {
            user.user_personal_info.dateOfBirth = moment(new Date(user.user_personal_info.dateOfBirth)).toDate();
          }
          console.log("user?.user_personal_info", user);
          this.setState({ userPersonalInfo: user?.user_personal_info });
          this.setState({ jobs: user?.jobs });
          this.setState({ userFinancialInfo: user.user_financial_info });

          console.log("user.user_financial_info.otStatus", user.user_financial_info);
          this.setState({
            userFinancialInfo: {
              ...user.user_financial_info,
              otStatus: user.user_financial_info.otStatus,
              esicStatus: user.user_financial_info.esicStatus,
              esic_number: user.user_financial_info.esic_number || "",
            },
          });
          this.setState({ employee: user.employee, loading: false });
        })
        .catch(err => {
          this.setState({ loading: false });
          console.log(err);
        });

      axios({
        method: 'get',
        url: '/departments',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
        .then(res => {
          this.setState({ departments: res.data, loading: false });
        })
        .catch(err => {
          this.setState({ loading: false });
          console.log(err);
        });
    } else {
      this.setState({ falseRedirect: true, loading: false });

    }
  }


  handleChangeUser = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        user: {
          ...prevState.errors.user,
          [name]: ""
        }
      }
    }));
  };

  handleChangeReportTo = (event) => {
    const { value, name } = event.target;
    this.setState((prevState) => ({
      reportingUser: {
        ...prevState.reportingUser,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        reportingUser: {
          ...prevState.errors.reportingUser,
          [name]: ""
        }
      }
    }));
  };
  handleChangeRole = (event) => {
    const { value, name } = event.target;
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        user: {
          ...prevState.errors.user,
          [name]: ""
        }
      }
    }));
  };

  // togglePasswordVisibility = () => {
  //   this.setState((prevState) => ({
  //     user: {
  //       ...prevState.user,
  //       showPassword: !prevState.user.showPassword  // Toggle inside user
  //     }
  //   }));
  // };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        [name]: value
      }
    }));
  };

  handleChangeDepartment = (event) => {
    const { value, name } = event.target;
    this.setState((prevState) => ({
      department: {
        ...prevState.department,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        department: {
          ...prevState.errors.department,
          [name]: ""
        }
      }
    }));
  };

  handleChangeUserPersonal = (event) => {
    const { value, name } = event.target;
    this.setState((prevState) => ({
      userPersonalInfo: {
        ...prevState.userPersonalInfo,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        userPersonalInfo: {
          ...prevState.errors.userPersonalInfo,
          [name]: ""
        }
      }
    }));
  };

  handleCheckboxChange = () => {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        active: !prevState.user.active
      }
    }));
  };

  handleChangeBankDetails = (event) => {
    const { value, name } = event.target;
    this.setState((prevState) => ({
      userFinancialInfo: {
        ...prevState.userFinancialInfo,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        userFinancialInfo: {
          ...prevState.errors.userFinancialInfo,
          [name]: ""
        }
      }
    }));
  };


  handleChangeUserFinancial = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };

    let updatedValue = value;
    if (["salaryBasic", "salaryGross", "salaryNet"].includes(name)) {
      updatedValue = value.replace(/\D/g, "").slice(0, 8);
      if (updatedValue.trim() === "") {
        errors.userFinancialInfo = {
          ...errors.userFinancialInfo,
          [name]: `${name} is required`,
        };
      } else if (!/^\d{1,8}$/.test(updatedValue)) {
        errors.userFinancialInfo = {
          ...errors.userFinancialInfo,
          [name]: `Enter a valid ${name} (1-8 digits)`,
        };
      } else {
        errors.userFinancialInfo = {
          ...errors.userFinancialInfo,
          [name]: "",
        };
      }
    }

    this.setState((prevState) => ({
      userFinancialInfo: {
        ...prevState.userFinancialInfo,
        [name]: updatedValue ? Number(updatedValue) : +value,
      },
      errors,
    }));
  };

  handleChangeEmployeeChange = (event) => {
    const { value, name } = event.target;
    this.setState((prevState) => ({
      employee: {
        ...prevState.employee,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        employee: {
          ...prevState.errors.employee,
          [name]: /^[A-Za-z\s]+$/.test(value) && value.length >= 2 && value.length <= 30 ? "" : prevState.errors.employee[name]
        }
      }
    }));
  };

  pushEmployees = () => {
    let empList = [];
    this.state.employeeList.map((emp, index) => {
      empList.push(
        <>
          <option key={index} value={emp.id}>
            {emp.fullName}
          </option>
        </>
      );
    });
    return empList;
  };

  pushRoles = () => {
    let rList = [];
    this.state.roleList.map((emp, index) => {
      rList.push(
        <>
          <option key={index} value={emp.id}>
            {emp.name}
          </option>
        </>
      );
    });
    return rList;
  };


  pushDepartments = () => {
    let items = [];
    this.state.departments.map((dept, index) => {
      items.push(
        <>
          <option key={index} value={dept.id}>{dept.departmentName}</option>
        </>
      );
    });
    return items;
  };

  updateUser = async (userId) => {
    const userData = {
      fullName: this.state.user.fullName,
      roleId: this.state.user.roleId,
      departmentId: this.state.user.departmentId,
      active: this.state.user.active,
      // password: this.state.user.password,
      reportid: this.state.reportingUser.reportid,
    };

    return axios.put(`/users/${userId}`, userData, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
  };


  updatePersonalInfo = async (userId) => {
    const userPersonalData = {
      dateOfBirth: moment(this.state.userPersonalInfo.dateOfBirth).format('YYYY-MM-DD'),
      gender: this.state.userPersonalInfo.gender,
      maritalStatus: this.state.userPersonalInfo.maritalStatus,
      fatherName: this.state.userPersonalInfo.fatherName,
      idNumber: this.state.userPersonalInfo.idNumber,
      address: this.state.userPersonalInfo.address,
      city: this.state.userPersonalInfo.city,
      country: this.state.userPersonalInfo.country,
      mobile: this.state.userPersonalInfo.mobile,
      phone: this.state.userPersonalInfo.phone,
      emailAddress: this.state.userPersonalInfo.emailAddress,
      userId: userId
    };

    return axios.put(`/personalInformations/${userId}`, userPersonalData, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
  };
  updateFinancialInfo = async (userId) => {
    // debugger
    const { userFinancialInfo } = this.state;
    let salaryGross =
      userFinancialInfo.salaryBasic +
      userFinancialInfo.allowanceHouseRent +
      userFinancialInfo.allowanceMedical +
      userFinancialInfo.allowanceSpecial +
      userFinancialInfo.allowancePhoneBill +
      userFinancialInfo.allowanceFuel +
      userFinancialInfo.allowanceOther;
    let deductionTotal =
      userFinancialInfo.deductionTax +
      userFinancialInfo.deductionOther +
      userFinancialInfo.deductionProvidentFund;
    let salaryNet = salaryGross - deductionTotal;
    let allowanceTotal =
      userFinancialInfo.allowanceHouseRent +
      userFinancialInfo.allowanceMedical +
      userFinancialInfo.allowanceSpecial +
      userFinancialInfo.allowanceFuel +
      userFinancialInfo.allowancePhoneBill +
      userFinancialInfo.allowanceOther;

    const userFinancialData = {
      ...userFinancialInfo,
      salaryGross,
      deductionTotal,
      salaryNet,
      allowanceTotal,
      userId,
    };
    return axios.put(`/financialInformations/${userId}`, userFinancialData, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
  };

  updateEmployee = async (userId) => {
    const employee = {
      Aadhaar_number: this.state.employee.pan_number,
      pan_number: this.state.employee.pan_number,
      esic_number: this.state.employee.esic_number,
      pf_number: this.state.employee.pf_number,
      nominee_name: this.state.employee.nominee_name,
      nominee_relation: this.state.employee.nominee_relation,
    };

    return axios.put(`/employee/update/${userId}`, employee, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
  };

  updateJobDetails = async (userId) => {
    const jobData = {
      jobTitle: this.state.jobs[0]?.jobTitle || '',
      startDate: this.state.jobs[0]?.startDate ? moment(this.state.jobs[0].startDate).format('YYYY-MM-DD') : null,
      endDate: this.state.jobs[0]?.endDate ? moment(this.state.jobs[0].endDate).format('YYYY-MM-DD') : null,
      userId: userId
    };


    if (this.state.jobs[0]?.id) {
      return axios.put(`/jobs/${this.state.jobs[0].id}`, jobData, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
    } else {
      return axios.post('/jobs', jobData, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
    }
  };
  handleError = (err) => {
    console.error("Error:", err);

    this.setState({
      hasError: true,
      errMsg: err.response?.data?.message || "An unexpected error occurred.",
      toastMessage: "Employee not updated!",
      toastVariant: 'danger',
      color: 'red',
      showToast: true,
    });

    setTimeout(() => {
      this.setState({ loading: false, showToast: false });
    }, 900);

    window.scrollTo(0, 0);
  };

  onSubmit = async (e) => {

    this.setState({ loading: true });
    e.preventDefault();
    const { user, userPersonalInfo, reportingUser, userFinancialInfo, employee } = this.state;
    const errors = validateEditEmployeeForm({ user, userPersonalInfo, reportingUser, userFinancialInfo, employee });
    if (Object.values(errors).some((err) => err && Object.keys(err).length > 0)) {
      this.setState({
        errors,
        loading: false,
        toastMessage: "Please fill the required fields!",
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      });
      window.scrollTo(0, 0);
      return;
    }

    try {
      const userId = this.props.location.state.selectedUser.id;

      // Update User
      await this.updateUser(userId);

      // Update Personal Info
      await this.updatePersonalInfo(userId);

      // Update Financial Info
      await this.updateFinancialInfo(userId);

      if (this.state.jobs[0]?.jobTitle) {
        await this.updateJobDetails(userId);
      }
      // Update Employee Details
      if (userId) {
        await this.updateEmployee(userId);
      }

      this.setState({
        completed: true,
        toastMessage: "Employee updated successfully!",
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });

      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/employee-list");
      }, 900);
    } catch (err) {
      this.handleError(err);
    }
  };


  fetchData = async () => {
    this.setState({ loading: true });
    try {
      const departmentResponse = await axios.get("/departments", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      this.setState({ departments: departmentResponse.data });
      const usersResponse = await axios.get("/users", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      console.log("usersResponse.data 586--", usersResponse.data);
      this.setState({ employeeList: usersResponse.data, loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error("Error fetching data:", error);
    }
  };

  fetchRoleData = async () => {
    this.setState({ loading: true });
    try {
      const usersResponse = await axios.get("/role", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      console.log("roleDAta is here:", usersResponse?.data.roles);
      this.setState({ roleList: usersResponse?.data.roles, loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error("Error fetching data:", error);
    }
  };


  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/employee-list");
      this.setState({ loading: false });
    }, 500);
  };

  render() {
    let salaryGross = this.state.userFinancialInfo.salaryBasic + this.state.userFinancialInfo.allowanceHouseRent +
      this.state.userFinancialInfo.allowanceMedical + this.state.userFinancialInfo.allowanceSpecial +
      this.state.userFinancialInfo.allowancePhoneBill + this.state.userFinancialInfo.allowanceFuel +
      this.state.userFinancialInfo.allowanceOther;
    let deductionTotal = this.state.userFinancialInfo.deductionTax + this.state.userFinancialInfo.deductionOther + this.state.userFinancialInfo.deductionProvidentFund;
    let salaryNet = salaryGross - deductionTotal;
    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <Form onSubmit={this.onSubmit}>
          <CommonLoader isLoading={this.state.loading}>
            <>
              <Card className="col-sm-12 main-card">
                <Card.Header>
                  <b>{this.state.isEdit ? 'Update Employee' : 'Add Employee'}</b>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    {/* start Personal Details Card */}
                    <div className="col-sm-6">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Personal Details</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Form.Group controlId="formFullName">
                              <Form.Label className="text-muted required">
                                Full Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter first Name"
                                name="fullName"
                                value={this.state.user.fullName}
                                onChange={this.handleChangeUser}
                              />
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.user?.fullName && (
                                <small className="text-danger">{this.state.errors.user.fullName}</small>
                              )}
                            </span>
                            <Form.Group controlId="formDateofBirth">
                              <Form.Label className="text-muted required">
                                Date of Birth
                              </Form.Label>
                              <Form.Row>
                                <DatePicker
                                  selected={this.state.userPersonalInfo.dateOfBirth}
                                  onChange={(dateOfBirth) => {
                                    let errors = { ...this.state.errors.userPersonalInfo };
                                    if (dateOfBirth) {
                                      delete errors.userPersonalInfo?.dateOfBirth;
                                    }
                                    this.setState(prevState => ({
                                      userPersonalInfo: {
                                        ...prevState.userPersonalInfo,
                                        dateOfBirth
                                      },
                                      errors
                                    }));
                                  }}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  name="dateOfBirth"
                                  dateFormat="dd/MM/yyyy"
                                  className="form-control ml-1"
                                  placeholderText="Select Date Of Birth"
                                  autoComplete="off"
                                />
                              </Form.Row>
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.userPersonalInfo?.dateOfBirth && <small className="text-danger">{this.state.errors?.userPersonalInfo?.dateOfBirth}</small>}
                            </span>
                            <Form.Group controlId="formGender">
                              <Form.Label className="text-muted required">
                                Gender
                              </Form.Label>
                              <Form.Control
                                as="select"
                                className="form-select"
                                value={this.state.userPersonalInfo.gender}
                                onChange={this.handleChangeUserPersonal}
                                name="gender"

                              >
                                <option value="">Choose...</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                              </Form.Control>
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.userPersonalInfo?.gender && (
                                <small className="text-danger">{this.state.errors.userPersonalInfo.gender}</small>
                              )}
                            </span>
                            <Form.Group controlId="formMaritalStatus">
                              <Form.Label className="text-muted required">
                                Marital Status
                              </Form.Label>
                              <Form.Control
                                as="select"
                                className="form-select"
                                value={this.state.userPersonalInfo.maritalStatus}
                                onChange={this.handleChangeUserPersonal}
                                name="maritalStatus"

                              >
                                <option value="">Choose...</option>
                                <option value="Married">Married</option>
                                <option value="Single">Single</option>
                              </Form.Control>
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.userPersonalInfo?.maritalStatus && (
                                <small className="text-danger">{this.state.errors.userPersonalInfo.maritalStatus}</small>
                              )}
                            </span>
                            <Form.Group controlId="formFatherName">
                              <Form.Label className="text-muted required">
                                Father's name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Father's Name"
                                name="fatherName"
                                value={this.state.userPersonalInfo.fatherName}
                                onChange={this.handleChangeUserPersonal}

                              />
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.userPersonalInfo?.fatherName && (
                                <small className="text-danger">{this.state.errors.userPersonalInfo.fatherName}</small>
                              )}
                            </span>
                            <Form.Group controlId="formId">
                              <Form.Label className="text-muted required">
                                ID Number
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter ID Number"
                                name="idNumber"
                                value={this.state.userPersonalInfo.idNumber || ""}
                                onChange={this.handleChangeUserPersonal}

                              />
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.userPersonalInfo?.idNumber && (
                                <small className="text-danger">{this.state.errors.userPersonalInfo.idNumber}</small>
                              )}
                            </span>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                    {/*end Personal Details Card */}

                    {/*start contact Details Card */}
                    <div className="col-sm-6">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Contact Details</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Form.Group controlId="formPhysicalAddress">
                              <Form.Label className="text-muted required">
                                Physical Address
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userPersonalInfo?.address}
                                onChange={this.handleChangeUserPersonal}
                                name="address"
                                placeholder="Enter Address"

                              />
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.userPersonalInfo?.address && (
                                <small className="text-danger">{this.state.errors.userPersonalInfo.address}</small>
                              )}
                            </span>
                            <Form.Group controlId="formCountry">
                              <Form.Label className="text-muted required">
                                Country
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userPersonalInfo.country}
                                onChange={this.handleChangeUserPersonal}
                                name="country"
                                placeholder="Enter Country"

                              />
                              <span className="login-error">
                                {this.state.errors?.userPersonalInfo?.country && (
                                  <small className="text-danger">{this.state.errors.userPersonalInfo.country}</small>
                                )}
                              </span>
                            </Form.Group>
                            <Form.Group controlId="formCity">
                              <Form.Label className="text-muted required">
                                City
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userPersonalInfo.city}
                                onChange={this.handleChangeUserPersonal}
                                name="city"
                                placeholder="Enter City"

                              />
                              <span className="login-error">
                                {this.state.errors?.userPersonalInfo?.city && (
                                  <small className="text-danger">{this.state.errors.userPersonalInfo.city}</small>
                                )}
                              </span>
                            </Form.Group>
                            <Form.Group controlId="formMobile">
                              <Form.Label className="text-muted required">
                                Mobile
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userPersonalInfo.mobile}
                                onChange={this.handleChangeUserPersonal}
                                name="mobile"
                                placeholder="Enter Mobile"

                              />
                              <span className="login-error">
                                {this.state.errors?.userPersonalInfo?.mobile && (
                                  <small className="text-danger">{this.state.errors.userPersonalInfo.mobile}</small>
                                )}
                              </span>
                            </Form.Group>
                            <Form.Group controlId="formPhone">
                              <Form.Label className="text-muted">
                                Landline
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userPersonalInfo.phone || ''}
                                onChange={this.handleChangeUserPersonal}
                                name="phone"
                                placeholder="Enter Phone"
                              />
                              <span className="login-error">
                                {this.state.errors?.userPersonalInfo?.phone && (
                                  <small className="text-danger">{this.state.errors.userPersonalInfo.phone}</small>
                                )}
                              </span>
                            </Form.Group>
                            <Form.Group controlId="formEmail">
                              <Form.Label className="text-muted ">
                                Email
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userPersonalInfo.emailAddress}
                                onChange={this.handleChangeUserPersonal}
                                name="emailAddress"
                                placeholder="Enter Email"
                              />
                              <span className="login-error">
                                {this.state.errors?.userPersonalInfo?.emailAddress && (
                                  <small className="text-danger">{this.state.errors.userPersonalInfo.emailAddress}</small>
                                )}
                              </span>
                            </Form.Group>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                    {/*end contact Details Card */}
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Bank Information</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Form.Group controlId="formBankName">
                              <Form.Label className="text-muted">
                                Bank Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userFinancialInfo.bankName}
                                onChange={this.handleChangeBankDetails}
                                name="bankName"
                                placeholder="Enter Bank name"
                              />
                              <span className="login-error">
                                {this.state.errors?.userFinancialInfo?.bankName && (
                                  <small className="text-danger">{this.state.errors.userFinancialInfo.bankName}</small>
                                )}
                              </span>
                            </Form.Group>
                            <Form.Group controlId="formAccountName">
                              <Form.Label className="text-muted">
                                Account Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userFinancialInfo.accountName}
                                onChange={this.handleChangeBankDetails}
                                name="accountName"
                                placeholder="Enter Account name"
                              />
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.userFinancialInfo?.accountName && (
                                <small className="text-danger">{this.state.errors.userFinancialInfo.accountName}</small>
                              )}
                            </span>
                            <Form.Group controlId="formAccountNumber">
                              <Form.Label className="text-muted">
                                Account Number
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userFinancialInfo.accountNumber}
                                onChange={this.handleChangeBankDetails}
                                name="accountNumber"
                                placeholder="Enter Account number"
                              />
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.userFinancialInfo?.accountNumber && (
                                <small className="text-danger">{this.state.errors.userFinancialInfo.accountNumber}</small>
                              )}
                            </span>
                            <Form.Group controlId="formIban">
                              <Form.Label className="text-muted">IFSC Code </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state.userFinancialInfo.iban}
                                onChange={this.handleChangeBankDetails}
                                name="iban"
                                placeholder="Enter IFSC"
                              />
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.userFinancialInfo?.iban && (
                                <small className="text-danger">{this.state.errors.userFinancialInfo.iban}</small>
                              )}
                            </span>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-sm-6">
                      <Card className="shadow-sm rounded border-0 card">

                        <Card.Header>Official Status</Card.Header>
                        <div className="login-required">
                          <Form.Group controlId="formCheckbox required">
                            <Form.Check
                              type="checkbox"
                              label=" Login required "
                              checked={this.state.user.active}
                              onChange={this.handleCheckboxChange}
                            />
                          </Form.Group>
                        </div>
                        <Card.Body>
                          <Card.Text>
                            <Form.Group controlId="formEmployeeId">
                              <Form.Label className="text-muted">
                                Employee ID
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={this.state?.user.username}
                                // onChange={this.handleChangeUserFinancial}
                                name="username"
                                readOnly
                                placeholder="Enter username"
                              />
                            </Form.Group>
                            <Form.Group controlId="formDepartment">
                              <Form.Label className="text-muted required">
                                Department
                              </Form.Label>
                              <Form.Control
                                as="select"
                                className="form-select"
                                value={this.state.user.departmentId}
                                onChange={this.handleChangeUser}
                                name="departmentId"
                              >
                                <option value="">Select Department</option>
                                {this.pushDepartments()}
                              </Form.Control>
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.user?.departmentId && (
                                <small className="text-danger">{this.state.errors.user.departmentId}</small>
                              )}
                            </span>
                            {/* {
                              this.state.user.active &&
                              <>
                                <Form.Group controlId="formPassword">
                                  <Form.Label className="text-muted required">
                                    Password
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      type={this.state.user.showPassword ? "text" : "password"}
                                      value={this.state.user.password}
                                      onChange={this.handleChange}
                                      name="password"
                                      placeholder="Enter password"
                                    />
                                    <InputGroup.Append>
                                      <Button
                                        variant="outline-secondary"
                                        onClick={this.togglePasswordVisibility}
                                      >
                                        {this.state.user.showPassword ? "Hide" : "Show"}
                                      </Button>
                                    </InputGroup.Append>
                                  </InputGroup>
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors.user.password && <small className="text-danger">{this.state.errors.user.password}</small>}
                                </span>
                              </>
                            } */}
                            <Form.Group controlId="formReportTo">
                              <Form.Label className="text-muted required">
                                Role
                                {/* -->{this.state.user.roleId} */}
                              </Form.Label>
                              <Form.Control
                                as="select"
                                className="form-select"
                                value={this.state.user.roleId || this.state.roleId}
                                onChange={this.handleChangeRole}
                                name="roleId">
                                <option value="">Select Role</option>
                                {this.pushRoles()}
                              </Form.Control>
                            </Form.Group>
                            <span className="login-error">
                              {this.state.errors?.user?.roleId && (
                                <small className="text-danger">{this.state.errors.roleId?.name}</small>
                              )}
                            </span>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                      <div className="col-sm-6">

                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Nominee Details</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Row>
                              <Col sm={6}>
                                <Form.Group controlId="formNomineeName">
                                  <Form.Label className="text-muted required">
                                    Nominee Name
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={this.state.employee.nominee_name}
                                    onChange={this.handleChangeEmployeeChange}
                                    name="nominee_name"
                                    placeholder="Enter Nominee Name"
                                  />
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.employee?.nominee_name && (
                                    <small className="text-danger">{this.state.errors.employee.nominee_name}</small>
                                  )}
                                </span>
                              </Col>
                              <Col sm={6}>
                                <Form.Group controlId="formNomineeRelation">
                                  <Form.Label className="text-muted required">
                                    Relation with Nominee
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={this.state.employee.nominee_relation}
                                    onChange={this.handleChangeEmployeeChange}
                                    name="nominee_relation"
                                    placeholder="Enter Relation with Nominee "
                                  />
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.employee?.nominee_relation && (
                                    <small className="text-danger">{this.state.errors.employee.nominee_relation}</small>
                                  )}
                                </span>
                              </Col>
                            </Row>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Job Details</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Row>
                              <Col sm={6}>
                                <Form.Group controlId="formJobTitle">
                                  <Form.Label className="text-muted required">
                                    Job Title
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={this.state.jobs[0]?.jobTitle || ''}
                                    onChange={(e) => {
                                      const { value } = e.target;
                                      this.setState(prevState => ({
                                        jobs: [{
                                          ...prevState.jobs[0],
                                          jobTitle: value
                                        }]
                                      }));
                                    }}
                                    name="jobTitle"
                                    placeholder="Enter Job Title"
                                  />
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.jobs?.[0]?.jobTitle && (
                                    <small className="text-danger">{this.state.errors.jobs[0].jobTitle}</small>
                                  )}
                                </span>
                              </Col>
                              <Col sm={6}>
                                <Form.Group controlId="formStartDate">
                                  <Form.Label className="text-muted required">
                                    Start Date
                                  </Form.Label>
                                  <DatePicker
                                    selected={this.state.jobs[0]?.startDate ? new Date(this.state.jobs[0].startDate) : null}
                                    onChange={(startDate) => {
                                      this.setState(prevState => ({
                                        jobs: [{
                                          ...prevState.jobs[0],
                                          startDate
                                        }]
                                      }));
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    name="startDate"
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    placeholderText="Select Start Date"
                                    autoComplete="off"
                                  />
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.jobs?.[0]?.startDate && (
                                    <small className="text-danger">{this.state.errors.jobs[0].startDate}</small>
                                  )}
                                </span>
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col sm={6}>
                                <Form.Group controlId="formEndDate">
                                  <Form.Label className="text-muted">
                                    End Date
                                  </Form.Label>
                                  <DatePicker
                                    selected={this.state.jobs[0]?.endDate ? new Date(this.state.jobs[0].endDate) : null}
                                    onChange={(endDate) => {
                                      this.setState(prevState => ({
                                        jobs: [{
                                          ...prevState.jobs[0],
                                          endDate
                                        }]
                                      }));
                                    }}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    name="endDate"
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control"
                                    placeholderText="Select End Date"
                                    autoComplete="off"
                                    minDate={this.state.jobs[0]?.startDate ? new Date(this.state.jobs[0].startDate) : null}
                                  />
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.jobs?.[0]?.endDate && (
                                    <small className="text-danger">{this.state.errors.jobs[0].endDate}</small>
                                  )}
                                </span>
                              </Col>
                            </Row>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Documents Details</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Row>
                              {/* <Col sm={6}>
                                <Form.Group controlId="formAadharNumber">
                                  <Form.Label className="text-muted ">
                                    Aaadhar Number
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={this.state.employee.Aadhaar_number}
                                    onChange={this.handleChangeEmployeeChange}
                                    name="Aadhaar_number"
                                    placeholder="Enter Aadhar Number"
                                  />
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.employee?.Aadhaar_number && (
                                    <small className="text-danger">{this.state.errors.employee.Aadhaar_number}</small>
                                  )}
                                </span>
                              </Col> */}
                              <Col sm={12}>
                                <Form.Group controlId="formPfNumber">
                                  <Form.Label className="text-muted ">
                                    PF Number
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={this.state.employee.pf_number}
                                    onChange={this.handleChangeEmployeeChange}
                                    name="pf_number"
                                    placeholder="Enter PF Number"
                                  />
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.employee?.pf_number && (
                                    <small className="text-danger">{this.state.errors.employee.pf_number}</small>
                                  )}
                                </span>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <Form.Group controlId="formPanNumber">
                                  <Form.Label className="text-muted ">
                                    PAN Number
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={this.state.employee.pan_number}
                                    onChange={this.handleChangeEmployeeChange}
                                    name="pan_number"
                                    placeholder="Enter Pan Number"
                                  />
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.employee?.pan_number && (
                                    <small className="text-danger">{this.state.errors.employee.pan_number}</small>
                                  )}
                                </span>
                              </Col>
                              <Col sm={6}>
                                <Form.Group controlId="formReportTo">
                                  <Form.Label className="text-muted required">
                                    Report To
                                    {/* -->{this.state.reportingUser?.fullName}-{this.state?.user.reportid} */}
                                  </Form.Label>
                                  <Form.Control
                                    as="select"
                                    className="form-select"
                                    // value={this.state.reportingUser?.fullName || this.reportingUser?.reportid}
                                    value={this.state.reportingUser?.reportid}
                                    onChange={this.handleChangeReportTo}
                                    name="reportid">
                                    <option value="">Select Report to user</option>
                                    {this.pushEmployees()}
                                  </Form.Control>
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.reportingUser?.fullName && (
                                    <small className="text-danger">{this.state.errors.reportingUser.fullName}</small>
                                  )}
                                </span>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6}>
                                <Form.Group controlId="formEsicNumber">
                                  <Form.Label className="text-muted ">
                                    ESIC Number
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={this.state.employee.esic_number}
                                    onChange={this.handleChangeEmployeeChange}
                                    name="esic_number"
                                    placeholder="Enter Esic Number"
                                    disabled={this.state.userFinancialInfo.esicStatus == "No"}

                                  />
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.employee?.esic_number && (
                                    <small className="text-danger">{this.state.errors.employee.esic_number}</small>
                                  )}
                                </span>
                              </Col>

                              <Col sm={6}>
                                <div className="status-esic">
                                  <p className="radio_class">ESIC Status</p>
                                  <div className="d-flex gap-4 border rounded p-2 bg-light">
                                    <Form.Check

                                      label="Yes"
                                      type="radio"
                                      name="esicStatus"
                                      value="Yes" // Capitalized to match API response
                                      checked={this.state.userFinancialInfo.esicStatus === "Yes"}
                                      onChange={this.handleEcisChange}
                                    />

                                    <Form.Check

                                      label="No"
                                      type="radio"
                                      name="esicStatus"
                                      value="No" // Capitalized to match API response
                                      checked={this.state.userFinancialInfo.esicStatus === "No"}
                                      onChange={this.handleEcisChange}
                                    />
                                  </div>
                                </div>
                              </Col>

                            </Row>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Salary Details</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Row>
                              <Col sm={3}>
                                <Form.Group>
                                  <Form.Label className="required radio_class">Employment Type</Form.Label>
                                  <Form.Control
                                    as="select"
                                    className="form-select"
                                    value={this.state.userFinancialInfo.employmentType}
                                    onChange={this.handleChangeBankDetails}
                                    name="employmentType"
                                  >
                                    <option value="">Choose one...</option>
                                    <option value="Full Time">Full Time</option>
                                    <option value="Part Time">Part Time</option>
                                  </Form.Control>
                                </Form.Group>
                                <span className="login-error">
                                  {this.state.errors?.userFinancialInfo?.employmentType && (
                                    <small className="text-danger">{this.state.errors?.userFinancialInfo?.employmentType}</small>
                                  )}
                                </span>
                              </Col>
                              <Col sm={3}>
                                <Form.Group controlId="formRelation">
                                  <Form.Label className="text-muted required">
                                    Basic Salary
                                  </Form.Label>
                                  <Form.Control
                                    type="number"
                                    value={this.state.userFinancialInfo.salaryBasic}
                                    onChange={this.handleChangeUserFinancial}
                                    name="salaryBasic"
                                    placeholder="Enter Basic Salary"
                                  />
                                </Form.Group>
                              </Col>
                              <Col sm={3}>
                                <Form.Label className="radio_class">
                                  Overtime (OT)
                                </Form.Label>
                                <div className="d-flex gap-4 border rounded p-1 bg-light">
                                  <Form.Check

                                    label="Yes"
                                    type="radio"
                                    name="otStatus"
                                    value="Yes"
                                    checked={this.state.userFinancialInfo.otStatus === "Yes"}
                                    onChange={this.handleOTChange}
                                  />
                                  <Form.Check

                                    label="No"
                                    type="radio"
                                    name="otStatus"
                                    value="No"
                                    checked={this.state.userFinancialInfo.otStatus === "No"}
                                    onChange={this.handleOTChange}
                                  />
                                </div>
                              </Col>
                              <Col sm={3}>
                                <Form.Group controlId="formRelation">
                                  <Form.Label className="text-muted required">
                                    Working Hours
                                  </Form.Label>
                                  <Form.Control
                                    type="number"
                                    value={this.state.userFinancialInfo.OtWorkingHours}
                                    onChange={this.handleChangeUserFinancial}
                                    name="OtWorkingHours"
                                    placeholder="Enter Working Hours"
                                  />
                                </Form.Group>
                              </Col>

                            </Row>

                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Allowances</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Form.Group controlId="formRentAllowance">
                              <Form.Label className="text-muted ">
                                House Rent Allowance
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={this.state.userFinancialInfo.allowanceHouseRent}
                                onChange={this.handleChangeUserFinancial}
                                name="allowanceHouseRent"
                                placeholder="Enter House Rent Allowance"
                              />
                            </Form.Group>
                            <Form.Group controlId="formMedicalAllowance">
                              <Form.Label className="text-muted   ">
                                Medical Allowance
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={this.state.userFinancialInfo.allowanceMedical}
                                onChange={this.handleChangeUserFinancial}
                                name="allowanceMedical"
                                placeholder="Enter Medical Allowance"
                              />
                            </Form.Group>
                            <Form.Group controlId="formSpecialAllowance">
                              <Form.Label className="text-muted   ">
                                Special Allowance
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={this.state.userFinancialInfo.allowanceSpecial}
                                onChange={this.handleChangeUserFinancial}
                                name="allowanceSpecial"
                                placeholder="Enter Special Allowance"
                              />
                            </Form.Group>
                            <Form.Group controlId="formFuelAllowance">
                              <Form.Label className="text-muted   ">
                                Fuel Allowance
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={this.state.userFinancialInfo.allowanceFuel}
                                onChange={this.handleChangeUserFinancial}
                                name="allowanceFuel"
                                placeholder="Enter Fuel Allowance"
                              />
                            </Form.Group>
                            <Form.Group controlId="formPhoneBillAllowance">
                              <Form.Label className="text-muted   ">
                                Food Allowance
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={this.state.userFinancialInfo.allowancePhoneBill}
                                onChange={this.handleChangeUserFinancial}
                                name="allowancePhoneBill"
                                placeholder="Enter Food Allowance"
                              />
                            </Form.Group>
                            <Form.Group controlId="formOtherAllowance">
                              <Form.Label className="text-muted   ">
                                Other Expenses
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={this.state.userFinancialInfo.allowanceOther}
                                onChange={this.handleChangeUserFinancial}
                                name="allowanceOther"
                                placeholder="Enter Other Expenses"
                              />
                            </Form.Group>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-sm-4">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Deductions</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Form.Group controlId="formPFDeduction">
                              <Form.Label className="text-muted   ">
                                PF Deduction
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={this.state.userFinancialInfo.deductionProvidentFund}
                                onChange={this.handleChangeUserFinancial}
                                name="deductionProvidentFund"
                                placeholder="Enter PF Deduction"
                              />
                            </Form.Group>
                            <Form.Group controlId="formTaxDeduction">
                              <Form.Label className="text-muted   ">
                                Tax Deduction
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={this.state.userFinancialInfo.deductionTax}
                                onChange={this.handleChangeUserFinancial}
                                name="deductionTax"
                                placeholder="Enter Tax Deduction"
                              />
                            </Form.Group>
                            <Form.Group controlId="formOtherDeduction">
                              <Form.Label className="text-muted   ">
                                Other Deduction
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={this.state.userFinancialInfo.deductionOther}
                                onChange={this.handleChangeUserFinancial}
                                name="deductionOther"
                                placeholder="Enter Other Deduction"
                              />
                            </Form.Group>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-sm-4">
                      <Card className="shadow-sm rounded border-0 card">
                        <Card.Header>Total Salary Details</Card.Header>
                        <Card.Body>
                          <Card.Text>
                            <Form.Group controlId="formGrossSalary">
                              <Form.Label className="text-muted  ">
                                Gross Salary
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={salaryGross}
                                readOnly
                                placeholder="Gross salary"
                              />
                            </Form.Group>
                            <Form.Group controlId="formTotalDeductions">
                              <Form.Label className="text-muted  ">
                                Total Deductions
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={deductionTotal}
                                readOnly
                                placeholder="Total deductions"
                              />
                            </Form.Group>
                            <Form.Group controlId="formNetSalary">
                              <Form.Label className="text-muted  ">
                                Net Salary
                              </Form.Label>
                              <Form.Control
                                type="number"
                                value={salaryNet}
                                readOnly
                                placeholder="Net salary"
                              />
                            </Form.Group>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                  <div className="add-cancel-btn">
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                      {this.state.isEdit ? 'Update' : 'Add'}
                    </Button>
                    <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" type="submit" onClick={this.handleBack}>
                      Cancel
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </>
          </CommonLoader>
        </Form >

      </div >
    );
  }
}